import api from '../../api';

const fetchQuotation = (propertyId, bricksQuantity) => {
  return api.get(`/crowdfundingProperties/${propertyId}/quoting?bricks=${bricksQuantity}`);
};

export default fetchQuotation;
